<div class="wrap" id="planning">

  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"
        appChangeColorTheme attribute="color"></fa-icon>
      <h2>Gestion de la planification du club: {{clubCode}}</h2>
    </div>
  </div>

  <div class="session_list_base">
    <h4>Selection de la session 1</h4>
    <fa-icon class="faInfoCircle" [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('counterInfosSearch')"
      appChangeColorTheme attribute="color"></fa-icon>

    <mat-form-field appearance="outline">
      <mat-label>Recherche</mat-label>
      <input matInput type="text" [formControl]="myControlSessionFirst"
        (input)="changeValueInput($event.target.value, 'session1')">
      <button *ngIf="myControlSessionFirst.value" matSuffix mat-icon-button aria-label="Clear"
        (click)="resetSearch('session1')">
        <fa-icon [icon]="getFaIcon('faTimes')"></fa-icon>
      </button>

    </mat-form-field>

    <ngx-simplebar class="session_list_content">
      <p class="no_value" *ngIf="valueInputFirst && !sessionFirstFiltered?.length">Auncune session trouvée</p>
      <ng-container
        *ngFor="let s of !sessionFirstFiltered?.length && !valueInputFirst ?  bookingSessions : sessionFirstFiltered">
        <div class="session_list_item">

          <div class="img" appIntersectionObserver (intersecting)="s.isVisible = $event">
            <app-image-offer *ngIf="s.isVisible" [offerKey]="s.offerKey" [width]="100"
              [height]="'100%'"></app-image-offer>

            <mat-checkbox [color]="color" [checked]="keySessionSelected === s.sessionKey"
              (change)="changeSessionSelected(s.sessionKey, s)"></mat-checkbox>
          </div>
          <div class="list_offers_description">
            <h4>{{ s.dateLib}}</h4>
            <h5>Offre: <strong>{{s.offerName}}</strong> - {{s.offerKey}}</h5>
            <div class="offer_session">
              <fa-icon [icon]="getFaIcon('faCalendarAlt')" appChangeColorTheme attribute="color"></fa-icon>
              {{s.sessionStartDate | date:'short':'UTC'}} - {{s.sessionEndDate | date:'short':'UTC'}}
            </div>

            <div class="trainees" *ngIf="s.trainees?.length">
              <fa-icon [icon]="getFaIcon('faUsers')" appChangeColorTheme attribute="color"></fa-icon>
              {{s.trainees?.length}}
            </div>
          </div>
        </div>
      </ng-container>
    </ngx-simplebar>

  </div>


  <div class="session_list_compare">
    <div class="session_list_compare_content">
      <h4>Selection de la session 2
        <br>
        <mat-slide-toggle class="slideToggleSessionTwo" size="large" (change)="filterSessionsSecondByOffer($event)"
          [color]="color" [checked]="filterSessionsByOffer"
          [matTooltip]="filterSessionsByOffer ?  'Glisser pour afficher les sessions de toutes les offres': 'Glisser pour restreindre les sessions à l\'offre ' + sessionSelected.offerKey"></mat-slide-toggle>
        <span class="slideText"
          [innerText]="filterSessionsByOffer ?  '(Glisser pour afficher les sessions de toutes les offres)': '(Glisser pour restreindre les sessions à l\'offre ' + sessionSelected.offerKey + ')'">

        </span>
      </h4>

      <fa-icon class="faInfoCircle" [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('counterInfosSearch')"
        appChangeColorTheme attribute="color"></fa-icon>

      <mat-form-field appearance="outline">
        <mat-label>Recherche</mat-label>
        <input matInput type="text" [formControl]="myControlSessionSecond"
          (input)="changeValueInput($event.target.value, 'session2')">
        <button *ngIf="myControlSessionSecond.value" matSuffix mat-icon-button aria-label="Clear"
          (click)="resetSearch('session2')">
          <fa-icon [icon]="getFaIcon('faTimes')"></fa-icon>
        </button>

      </mat-form-field>

      <ngx-simplebar class="session_list_content">
        <p class="no_value" *ngIf="valueInputSecond && !sessionSecondFiltered?.length">Auncune session trouvée</p>

        <ng-container
          *ngFor="let s of !sessionSecondFiltered?.length && !valueInputSecond ?  bookingSessionsToCompare : sessionSecondFiltered">
          <div class="session_list_item">

            <div class="img">
              <app-image-offer [offerKey]="s.offerKey" [width]="100" [height]="'100%'"></app-image-offer>

              <mat-checkbox [color]="color" [checked]="keySessionCompare === s.sessionKey"
                (change)="changeSessionToCompare(s.sessionKey, s)"></mat-checkbox>
            </div>
            <div class="list_offers_description">
              <h4>{{ s.dateLib}}</h4>
              <h5>Offre: <strong>{{s.offerName}}</strong> - {{s.offerKey}}</h5>
              <div class="offer_session">
                <fa-icon [icon]="getFaIcon('faCalendarAlt')" appChangeColorTheme attribute="color"></fa-icon>
                {{s.sessionStartDate | date:'short':'UTC'}} - {{s.sessionEndDate |date:'short':'UTC'}}
              </div>

              <div class="trainees" *ngIf="s.trainees?.length">
                <fa-icon [icon]="getFaIcon('faUsers')" appChangeColorTheme attribute="color"></fa-icon>
                {{s.trainees?.length}}
              </div>

            </div>

          </div>
        </ng-container>

      </ngx-simplebar>
    </div>
  </div>

  <div class="session_selected_background" appChangeColorTheme attribute="bgc" rgba="0.1">
  </div>

  <div class="title_session_1">
    Session 1 selectionnée
  </div>

  <div class="session_overview">


    <div class="mat_spinner" *ngIf="!showSessionSelected">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <div class="session_list_item" *ngIf="showSessionSelected && sessionSelected">

      <div class="img">
        <!-- <img [src]="getImgUrl(sessionSelected?.image)" [alt]="sessionSelected?.offerName"> -->
        <app-image-offer *ngIf="sessionSelected?.offerKey" [offerKey]="sessionSelected?.offerKey" [width]="100"
          [height]="'100%'"></app-image-offer>

      </div>

      <div class="list_offers_description">
        <h4>{{ sessionSelected?.dateLib}}</h4>
        <h5>Offre: <strong>{{sessionSelected?.offerName}}</strong></h5>
        <div class="offer_session">
          <fa-icon [icon]="getFaIcon('faCalendarAlt')" appChangeColorTheme attribute="color"></fa-icon>
          {{sessionSelected?.sessionStartDate | date:'short'}} - {{sessionSelected?.sessionEndDate |date:'short'}}
        </div>

        <div class="trainees">
          <fa-icon [icon]="getFaIcon('faUsers')" appChangeColorTheme attribute="color"></fa-icon>
          {{sessionSelected?.trainees ? sessionSelected?.trainees?.length : sessionSelected?.quantity}}
        </div>

      </div>

    </div>
    <p class="no_value" [style.padding]="'auto'" *ngIf="showSessionSelected && !sessionSelected">Aucune
      <strong>session 1 </strong>selectionnée
    </p>
  </div>

  <!-- <div class="planing_ressource">
      <h4>Planifications des ressources</h4>
    </div> -->

  <div class="resources_sessions" cdkDropListGroup>

    <div class="ressources_of_session">
      <h4>Ressources de la session 1 (<strong>{{resourceSession?.length || 0}}</strong>)</h4>
      <div class="mat_spinner" *ngIf="!showSessionSelected">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>

      <ngx-simplebar *ngIf="showSessionSelected">
        <div cdkDropList [cdkDropListData]="resourceSession" class="example-list" cdkDropListSortingDisabled
          (cdkDropListDropped)="drop($event, true)">
          <p class="no_value" *ngIf="!sessionSelected">Aucune <strong>session 1</strong> selectionnée</p>
          <p class="no_value" *ngIf="!resourceSession?.length && sessionSelected">Aucune ressource pour la
            <strong>session 1</strong>
          </p>

          <ng-container *ngIf="resourceSession?.length && sessionSelected">
            <div class="example-box" *ngFor="let item of resourceSession" cdkDrag> {{item.clubRessourcePseudo}}
              ({{item.clubRessourceFirstName}} {{item.clubRessourceLastName}})
            </div>
          </ng-container>
        </div>
      </ngx-simplebar>
    </div>

    <div class="ressources_of_club">
      <h4>Ressources du club (<strong>{{resources?.length || 0}}</strong>)</h4>
      <ngx-simplebar>
        <div cdkDropList [cdkDropListData]="resources" class="example-list" cdkDropListSortingDisabled
          (cdkDropListDropped)="drop($event)">
          <p class="no_value" *ngIf="!resources?.length">Aucune ressource pour le club</p>

          <ng-container *ngIf="resources?.length">
            <div class="example-box" *ngFor="let item of resources" cdkDrag [cdkDragData]="item">
              {{item.clubRessourcePseudo}} ({{item.clubRessourceFirstName}} {{item.clubRessourceLastName}})
            </div>
          </ng-container>
        </div>
      </ngx-simplebar>

    </div>
  </div>

  <div class="trainees_session" cdkDropListGroup>
    <div class="trainees_of_session">
      <h4>Stagiaires de la session 1 (<strong>{{traineesSessionSelected?.length || 0}}</strong>)</h4>
      <div class="mat_spinner" *ngIf="!showSessionSelected">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
      <ng-container *ngIf="showSessionSelected">

        <ngx-simplebar>
          <div cdkDropList id="session1" [cdkDropListData]="traineesSessionSelected" class="example-list"
            cdkDropListSortingDisabled (cdkDropListDropped)="drop($event)">
            <p class="no_value" *ngIf="!sessionSelected">Aucune <strong>session 1</strong> selectionnée</p>

            <p class="no_value" *ngIf="!traineesSessionSelected?.length && sessionSelected">Aucun stagiaire pour
              <strong>la session 1</strong>
            </p>

            <ng-container *ngIf="traineesSessionSelected?.length && sessionSelected">
              <div class="example-box" *ngFor="let item of traineesSessionSelected" cdkDrag>
                <div> {{item.traineeFirstName}} {{item.traineeLastName}}</div>
                <fa-icon [icon]="getFaIcon('faInfoCircle')" (click)="goCounter(item.traineeKey, 'session1')"></fa-icon>
              </div>
            </ng-container>
          </div>
        </ngx-simplebar>

        <div class="btn_action_session" *ngIf="sessionSelected">
          <button (click)="getPdfSession()" appChangeColorTheme attribute="bgc">Impression Fiche Session 1</button>
          <button (click)="getExcelSession()" appChangeColorTheme attribute="bgc">Export Session 1</button>
        </div>
      </ng-container>
    </div>

    <div class="trainees_of_club">
      <div class="trainees_of_club_content">
        <h4>Stagiaires de la session 2 (<strong>{{traineesSessionCompare?.length || 0}}</strong>)</h4>

        <div class="mat_spinner" *ngIf="!showSessionCompare">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>

        <ngx-simplebar *ngIf="showSessionCompare">
          <div cdkDropList id="session2" [cdkDropListData]="traineesSessionCompare" cdkDropListSortingDisabled
            class="example-list" (cdkDropListDropped)="drop($event)">
            <p class="no_value" *ngIf="!traineesSessionCompare?.length && !sessionToCompare">Aucune <strong>session
                2</strong> selectionnée</p>
            <p class="no_value" *ngIf="!traineesSessionCompare?.length && sessionToCompare">Aucun stagiaire pour
              <strong>la session 2</strong>
            </p>

            <ng-container *ngIf="traineesSessionCompare?.length && sessionToCompare">
              <div class="example-box" *ngFor="let item of traineesSessionCompare" cdkDrag>
                <div>{{item.traineeFirstName}} {{item.traineeLastName}}</div>
                <fa-icon [icon]="getFaIcon('faInfoCircle')" (click)="goCounter(item.traineeKey, 'session2')"></fa-icon>
              </div>
            </ng-container>

          </div>
        </ngx-simplebar>
      </div>
    </div>
  </div>
</div>